/**
 * exatrek REST API
 * Some custom description of API.
 *
 * The version of the OpenAPI document: v3
 * Contact: dev@exatrek.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FilterPropertyDto } from './filterPropertyDto';

export interface ActivitiesListRequestV2Dto {
  filter?: Array<FilterPropertyDto>;
  onlyOverview?: boolean;
  ownerUsername?: string;
  page?: number;
  size?: number;
  sort?: string[];
}
